import { useMemo } from "react";
import { getMenuGroupId, getMenuGroupItems, getMenuGroupTitle, getMenuSectionId } from "../../../utils/familyMenu";

const useMobilePanelMenu = ({ menuStructure, handleAllProductsNavigation, handleCatalogNavigation }) => {
  const panelMenuItems = useMemo(() => {
    const items = [
      {
        label: "Todos los productos",
        icon: "pi pi-th-large",
        command: () => handleAllProductsNavigation({ closeMobileDrawer: true }),
      },
    ];
    menuStructure.forEach((section) => {
      const hasGroups = Array.isArray(section?.groups) && section.groups.length > 0;
      const sectionItem = {
        label: section.name,
        icon: "pi pi-folder",
      };
      if (hasGroups) {
        sectionItem.items = section.groups.map((group) => {
          const groupItems = getMenuGroupItems(group);
          const groupItem = {
            label: getMenuGroupTitle(group),
          };
          if (groupItems.length > 0) {
            groupItem.items = [
              {
                label: `Ver todo en ${getMenuGroupTitle(group)}`,
                command: () => handleCatalogNavigation({
                  collection: section.name,
                  subcollection: getMenuGroupTitle(group),
                  familyId: getMenuGroupId(group),
                  closeMobileDrawer: true,
                }),
              },
              ...groupItems.map((subItem) => ({
                label: subItem.name,
                command: () => handleCatalogNavigation({
                  collection: section.name,
                  subcollection: subItem.name,
                  familyId: subItem.id,
                  closeMobileDrawer: true,
                }),
              })),
            ];
          } else {
            groupItem.command = () => handleCatalogNavigation({
              collection: section.name,
              subcollection: getMenuGroupTitle(group),
              familyId: getMenuGroupId(group),
              closeMobileDrawer: true,
            });
          }
          return groupItem;
        });
      } else {
        sectionItem.command = () => handleCatalogNavigation({
          collection: section.name,
          familyId: getMenuSectionId(section),
          closeMobileDrawer: true,
        });
      }
      items.push(sectionItem);
    });
    return items;
  }, [menuStructure, handleAllProductsNavigation, handleCatalogNavigation]);

  return panelMenuItems;
};

export default useMobilePanelMenu;